import { getBackVersion } from '../../config';
import { AuditStateSnapshot } from '../../models/Referral/AuditState';
import api from '../api';

const getAuditState = (): Promise<AuditStateSnapshot> => {
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/referral/audit_state`,
    });
};

export { getAuditState };
